import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ScoreCardMetricKey } from '@/components/modules/Metrics/shared/types/ScoreCardMetricKey';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface MetricsTypeToggleStyleProps {
  background: string;
  radius: number;
}

const useStyles = makeStyles({
  root: (props: MetricsTypeToggleStyleProps) => ({
    display: 'inline-flex',
    padding: 2,
    borderRadius: props.radius,
    backgroundColor: props.background,
  }),
  option: {
    height: 26,
  },
  unselected: {
    backgroundColor: 'transparent',
  },
});

interface MetricsTypeToggleProps {
  options: ScoreCardMetricKey[];
  selectedMetricsType: ScoreCardMetricKey;
  setSelectedMetricsType: React.Dispatch<React.SetStateAction<ScoreCardMetricKey>>;
}

export const MetricsTypeToggle = ({ options, selectedMetricsType, setSelectedMetricsType }: MetricsTypeToggleProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const classes = useStyles({ background: palette.minor.main, radius: customBorderRadius.button });

  return (
    <Box className={classes.root} role="group">
      {options.map((option) => (
        <Button
          key={option}
          size="small"
          variant="contained"
          disableElevation
          color={option === selectedMetricsType ? 'secondary' : 'default'}
          className={[classes.option, option === selectedMetricsType ? '' : classes.unselected].join(' ')}
          aria-pressed={option === selectedMetricsType}
          onClick={() => setSelectedMetricsType(option)}
        >
          <Text tId={option} />
        </Button>
      ))}
    </Box>
  );
};
